import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { SafeHTML } from '@thoughtspot/radiant-react/widgets/safe-html';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import { getClientId, getOidcLoginUriFromIssuers, } from '@thoughtspot/system-config-service';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { getPublicSamlConnections } from "../../../services/saml/saml-service";
import { useInvalidateUsersMutation } from "../../../services/session/session-service";
import { useSetTscliCommand } from "../../../services/tscli/tscli-service";
import { getIdentityV2PublicUrl, TranslationsKeys } from '../constant';
import styles from './iamv2-migration.module.scss';
const MIGRATION_DOCS_LINK = 'https://community.thoughtspot.com/s/article/ThoughtSpot-Cloud-IAMv2-Migration';
const SAML_CONFIG_KEY = 'orion.samlConfiguration.enabled';
export const IamV2MigrationAutomationBanner = ({ setScreenLoader, setShouldDisplayLoaderText, }) => {
    const { t } = useTranslation();
    const [urls, setUrls] = useState({
        assertionUrl: '',
        audienceUrl: '',
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const params = {
        configOperation: 'add',
        configOptions: [
            {
                optionKey: SAML_CONFIG_KEY,
                optionValue: btoa('false'),
                optionLabel: t(TranslationsKeys.IAM_V2_MIGRATION_AUTOMATION_CONFIRMATION_MODAL_TITLE, { lng: 'en-US' }),
            },
        ],
    };
    const { data: connectionsData, error, loading } = getPublicSamlConnections(`${getIdentityV2PublicUrl()}/${getClientId()}/idp/connections`);
    const { data: invalidateUserData, error: invalidateUserError, loading: invalidateUserLoading, invalidateUsers, } = useInvalidateUsersMutation();
    const onError = (error = null) => {
        setScreenLoader(false);
    };
    const onComplete = (response) => {
        try {
            if (response.Data !== null) {
                setScreenLoader(false);
                invalidateUsers([], false);
            }
            else if (response.Data === null) {
                onError();
            }
        }
        catch (err) {
            onError(err);
        }
    };
    const [updateSetting] = useSetTscliCommand(onComplete, onError, 'iamV2Migration', params);
    const handleConfigureClick = () => {
        setIsModalOpen(true);
    };
    const onDismissModal = () => {
        setIsModalOpen(false);
    };
    const onConfirmModal = () => {
        setIsModalOpen(false);
        setScreenLoader(true);
        setShouldDisplayLoaderText(true);
        updateSetting();
    };
    useEffect(() => () => {
        setShouldDisplayLoaderText(false);
    }, [0]);
    useEffect(() => {
        const oidcIssuer = getOidcLoginUriFromIssuers();
        if (!oidcIssuer) {
            return;
        }
        const url = new URL(getOidcLoginUriFromIssuers());
        if (!_.isEmpty(connectionsData)) {
            const connection = connectionsData[0];
            setUrls({
                assertionUrl: `${url.origin}/sso/saml2/${connection?.id}`,
                audienceUrl: `${connection?.audience || ''}`,
            });
        }
    }, [connectionsData]);
    const getBannerText = () => (React.createElement(Vertical, { spacing: "a" },
        React.createElement(SafeHTML, { html: t(TranslationsKeys.IAM_V2_MIGRATION_AUTOMATION_BANNER_CONTENT, {
                url: MIGRATION_DOCS_LINK,
            }), config: { ADD_ATTR: ['target'] } }),
        React.createElement(Vertical, null,
            urls.assertionUrl ? (React.createElement(Horizontal, { spacing: "b", className: styles.urlContainer },
                React.createElement(Typography, { variant: "p", className: styles.linkLabelCls }, t(TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_ACS_URL)),
                React.createElement(Typography, { variant: "p" }, ":"),
                React.createElement(Typography, { variant: "p-bold", className: styles.linkValueCls }, urls.assertionUrl))) : null,
            urls.audienceUrl ? (React.createElement(Horizontal, { spacing: "b", className: styles.urlContainer },
                React.createElement(Typography, { variant: "p", className: styles.linkLabelCls }, t(TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_AUDIENCE_URI)),
                React.createElement(Typography, { variant: "p" }, ":"),
                React.createElement(Typography, { variant: "p-bold", className: styles.linkValueCls }, urls.audienceUrl))) : null),
        React.createElement(SafeHTML, { html: t(TranslationsKeys.IAM_V2_MIGRATION_AUTOMATION_BANNER_SUB_CONTENT) }),
        React.createElement(Horizontal, { className: styles.submitButtonCls },
            React.createElement(Button, { text: t(TranslationsKeys.SUBMIT), type: "primary", size: "s", onClick: handleConfigureClick }))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Alert.Banner, { isVisible: true, message: getBannerText(), showCloseButton: false, type: BannerAlertType.INFO, "data-testid": "iam-v2-migration-automation-banner", className: styles.bannerCls }),
        isModalOpen && (React.createElement(Modal, { size: ModalSize.SMALL, title: t(TranslationsKeys.IAM_V2_MIGRATION_AUTOMATION_CONFIRMATION_MODAL_TITLE), isOpen: isModalOpen, confirmButton: {
                text: t(TranslationsKeys.SUBMIT),
                onConfirm: onConfirmModal,
            }, dismissButton: {
                text: t(TranslationsKeys.CANCEL),
            }, onDismiss: onDismissModal },
            React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
                React.createElement("div", { "data-testid": "confirmation-body" },
                    React.createElement(Typography, { variant: "p", noMargin: true }, t(TranslationsKeys.IAM_V2_MIGRATION_AUTOMATION_CONFIRMATION))))))));
};
//# sourceMappingURL=iamv2-migration.container.js.map